var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buttonSchema } from "../config";
var DefaultContextGenerator = /** @class */ (function () {
    function DefaultContextGenerator(config) {
        var _this = this;
        this.buttonEnricher = function (event) {
            // button plugin maps data-sp-button-label to label in the event
            return _this.getContext(event.label);
        };
        this.linkEnricher = function (anchorElement) {
            // link plugin passes the entire anchor element rather than an event so we can access the dataset directly
            return _this.getContext(anchorElement.dataset.spButtonLabel);
        };
        this.getContext = function (label) {
            if (!label) {
                return null;
            }
            var parsedData;
            try {
                parsedData = JSON.parse(label);
            }
            catch (error) {
                return null;
            }
            var data = {};
            if (parsedData.buttonName) {
                data.button_name = parsedData.buttonName;
                data.intent = parsedData.intent;
            }
            else if (this.eventMapping[parsedData.id]) {
                data = this.eventMapping[parsedData.id];
            }
            else {
                return null;
            }
            return {
                schema: buttonSchema,
                data: __assign({ button_id: parsedData.id }, data),
            };
        };
        this.eventMapping = config;
    }
    return DefaultContextGenerator;
}());
export { DefaultContextGenerator };
